module.exports = __webpack_public_path__ + "img/003-research.f2a166df.png";